import { colorIcon } from './PerilColorIcon.css'

export function PerilColorIcon({ color }: { color?: string }) {
  return <div className={colorIcon} style={{ backgroundColor: color }} />
}
